module.exports = __webpack_public_path__ + "img/GH-kyujin-top-012.63924cd6.webp";